/* eslint-disable @typescript-eslint/no-explicit-any */
import { SocketContext } from "@modules/practitioner/practitioner-module";
import { useCallback, useContext } from "react";

type SocketEvents = 'create_user' | 'create_call' | 'answer_call' | 'leave_call' | 'leave_call' | 'cancel_call'
// type SocketListen = 'new_active' | 'recive_call' | 'leave' | 'users_in_call' | 'no_event'

// interface EventListen {
//     event: SocketListen,
//     data: any
// }

// interface User {
//     name: string;
//     id: string;
// }

// interface BasicCall {
//     name: string;
//     id: string;
//     token: string;
// }

const useCallSocket = () => {
    const { socket } = useContext(SocketContext)

    const emitSocketEvent = useCallback((event: SocketEvents, data: any) => {
        if(socket && socket.connected) 
        {
            switch(event) 
            {
                case "create_user":
                    socket.emit("create_user", {username: data.username, name: data.name, role: data.role});
                    break;
                case "create_call":
                    socket.emit("create_call", {
                        nameEmit: data.name,
                        name: data.nameUser,
                        id: data.id,
                        token: data.token,
                        room: `${data.id}${socket.id}`,
                    });
                    break;
                case "answer_call":
                    socket.emit("answer_call", {
                        id: data.id,
                        idEmit: data.idEmit,
                        room: data.room,
                    });
                    break;
                case "leave_call":
                    socket.emit("leave_call", {
                        name: data.name,
                        id: data.id,
                        token: data.token,
                        room: data.room,
                        idEmit: data.idEmit,
                    });
                    break;
                case "cancel_call":
                    socket.emit("cancel_call", {
                        name: data.name,
                        id: data.id,
                        token: data.token,
                        room: data.room,
                        idEmit: data.nameEmit,
                    });
                    break;
            }
        }
        else
        {
            console.error("Socket is not defined", event)
        }
    }, [socket]);

    return {emitSocketEvent}
}

export default useCallSocket;
